// TODO: From App New
<template>
  <b-card>
    <FormView
      :data="$store.getters['bannerV2/detailData']"
      :fields="$store.getters['bannerV2/tableFields']"
      @load="loadData"
    />
  </b-card>
</template>

<script>
import FormView from '@/layouts/components/v2/FormView.vue'

import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    FormView,
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('bannerV2/getDetail', id)
    },
  },
}
</script>

<style scoped>

</style>
